import React, { useState } from 'react';

const DeleteWithConfirmation = ({
    onDelete,
    label = "Delete",
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    className = "btn btn-danger",
    disabled = false,
    isProcessing = false
}) => {
    const [isConfirming, setIsConfirming] = useState(false);

    const handleInitialClick = () => {
        setIsConfirming(true);
    };

    const handleCancel = () => {
        setIsConfirming(false);
    };

    const handleConfirm = () => {
        onDelete();
        // We don't automatically set isConfirming to false here,
        // assuming the parent might unmount or show a loading state via isProcessing
    };

    if (isConfirming) {
        return (
            <div className="btn-group btn-group-justified" role="group">
                <div className="btn-group" role="group">
                    <button
                        onClick={handleConfirm}
                        disabled={disabled || isProcessing}
                        className="btn btn-danger btn-xs"
                    >
                        {isProcessing ? '...' : confirmLabel}
                    </button>
                </div>
                <div className="btn-group" role="group">
                    <button
                        onClick={handleCancel}
                        disabled={disabled || isProcessing}
                        className="btn btn-default btn-xs"
                    >
                        {cancelLabel}
                    </button>
                </div>
            </div>
        );
    }

    return (
        <button
            onClick={handleInitialClick}
            disabled={disabled || isProcessing}
            className={className}
        >
            {isProcessing ? 'Processing...' : label}
        </button>
    );
};

export default DeleteWithConfirmation;
